import { render, staticRenderFns } from "./TxRowInlineSwap.vue?vue&type=template&id=1020d258"
import script from "./TxRowInlineSwap.vue?vue&type=script&lang=js"
export * from "./TxRowInlineSwap.vue?vue&type=script&lang=js"
import style0 from "./TxRowInlineSwap.vue?vue&type=style&index=0&id=1020d258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports